'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PublicationInfo = PublicationInfo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Show all information regarding a publication: when it has been first published, when it was updated, and what version it is.
 *
 * @param {object} props
 * @param {string} [props.publicationDate=window.project.publicationDate] Unix timestamp when the project has been first published
 * @param {string} [props.changeDate=window.project.changeDate] Unix timestamp when the project has been last updated.
 * @param {string} [props.version=window.project.version] Version number of the project
 * @param {string} [props.className] CSS class name of the whole object.
 * @param {string} [props.itemClassName] CSS class names for the individual items.
 * @param {string} [props.nameClassName] CSS class names for the key/name of the individual items.
 * @param {string} [props.valueClassName] CSS class names for the value of the individual items.
 */
function PublicationInfo(_ref) {
  var publicationDate = _ref.publicationDate,
      changeDate = _ref.changeDate,
      version = _ref.version,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$itemClassName = _ref.itemClassName,
      itemClassName = _ref$itemClassName === undefined ? '' : _ref$itemClassName,
      _ref$nameClassName = _ref.nameClassName,
      nameClassName = _ref$nameClassName === undefined ? '' : _ref$nameClassName,
      _ref$valueClassName = _ref.valueClassName,
      valueClassName = _ref$valueClassName === undefined ? '' : _ref$valueClassName;

  if (window.project) {
    publicationDate = publicationDate || window.project.publicationDate;
    changeDate = changeDate || window.project.changeDate;
    version = version || window.project.version;
  }

  // Collect all class names for individual items in a object
  var itemClasses = { itemClassName: itemClassName, nameClassName: nameClassName, valueClassName: valueClassName };

  return _react2.default.createElement(
    'div',
    { className: 'publication-info ' + className },
    _react2.default.createElement(_index.TimestampFormatter, _extends({ prefix: 'Erstellt: ', timestamp: publicationDate }, itemClasses)),
    _react2.default.createElement(_index.TimestampFormatter, _extends({ prefix: 'Letzte \xC4nderung: ', timestamp: changeDate }, itemClasses)),
    _react2.default.createElement(_index.VersionFormatter, _extends({ version: version }, itemClasses))
  );
}

exports.default = PublicationInfo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-publication-info/dist/publication-info.js
// module id = 727
// module chunks = 0